// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-module--layout--2iqws"};